import { variantSummary } from './variant-quantities.mjs';
import { CHECKING_FOOTER } from './checking-receipt';
import { receiptGroups } from './receipt-groups.mjs';
import { buildCompactEscpos } from './compact-receipt';
import { escposGeometry } from './receipt-geometry';

export function buildCheckingEscpos(tx, settings, cashier) {
  if (tx.receipt_scope === 'non_tobacco') return buildCompactEscpos(tx, settings);
  const groups = receiptGroups(tx.items);
  tx = { ...tx, items: groups.items };
  const geometry=escposGeometry(settings), width=geometry.columns;
  const bytes=[27,64,...geometry.commands];
  const clean=value=>String(value ?? '').replace(/[\x00-\x1f\x7f]/g,' ');
  const text=value=>{for(const char of value)bytes.push(char.charCodeAt(0)<256 ? char.charCodeAt(0) : 63);bytes.push(10);};
  const row=(value,align=0,bold=false,big=false)=>{
    bytes.push(27,97,align,27,69,bold?1:0,29,33,big?17:0);
    const chars=big?Math.floor(width/2):width;
    const str=clean(value);
    for(let n=0;n<str.length;n+=chars)text(str.slice(n,n+chars));
    bytes.push(29,33,0,27,69,0,27,97,0);
  };
  const rp=n=>'Rp'+Math.round(Number(n||0)).toLocaleString('id-ID');
  const pair=(left,right,bold=false)=>{
    left=clean(left);right=clean(right);
    if(left.length+right.length+1>width){row(left,0,bold);row(right,2,bold);}
    else row(left+' '.repeat(width-left.length-right.length)+right,0,bold);
  };
  const rule=()=>row('-'.repeat(width));
  row('BUKAN BUKTI',1,true,true);row('PEMBAYARAN',1,true,true);
  row('NOTA PENGECEKAN BARANG',1);row(settings.store_name||'POS MASIVI',1);
  if(tx.is_reprint)row('(REPRINT)',1);
  rule();row(tx.queue_number?'No. Antrean: '+tx.queue_number:'Status: Draf belum dikirim');
  row(new Date(tx.created_at).toLocaleString('id-ID'));row('Kasir input: '+(cashier||tx.cashier||''));
  if(tx.customer_name)row('Pelanggan: '+tx.customer_name,0,true);
  rule();
  for(const [index,item] of tx.items.entries()){
    if(index===groups.separator)rule();
    row(item.name);
    pair(`  ${item.qty} ${item.unit||item.price_level||'Pcs'} x ${rp(item.price)}`,rp(item.qty*item.price));
    if(variantSummary(item))row(variantSummary(item,' / '));
    if(item.discount>0)pair('Diskon item','-'+rp(item.discount));
    if(item.note)row('* '+item.note);
  }
  rule();pair('Subtotal',rp(tx.subtotal));
  if(tx.discount>0)pair('Diskon','-'+rp(tx.discount));
  for(const debt of tx.previous_debts||[])pair('Piutang sebelumnya ('+String(debt.invoice_no).slice(-4)+')',rp(debt.amount));
  pair('TOTAL',rp(tx.total+(tx.settlement_total||0)),true);
  pair('Jumlah Produk',tx.items.length);pair('Total QTY',Number(tx.items.reduce((n,i)=>n+Number(i.qty||0),0).toFixed(6)));
  if(tx.note)row('Catatan: '+tx.note);
  rule();row('Diperiksa oleh: ______________');
  for(const line of CHECKING_FOOTER.split('\n'))row(line,1,true);
  // No cash-drawer pulse: this document does not collect a payment.
  bytes.push(10,10,29,86,0);
  return new Uint8Array(bytes);
}
